import styled from "styled-components";
import {DropdownListJustify} from "./LanguageSelector";
import {tokens} from "../../../theme";

export const LanguageSelectorContainer = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const LanguageSelectorButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    
    gap: 2px;
`;

export const LanguageSelectorButtonLabelWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;

    text-transform: uppercase;
    letter-spacing: ${tokens.letterSpacing.wide};
    font-size: ${tokens.fontSize.xxs};
    font-weight: ${tokens.fontWeight.semibold};
    
    white-space: nowrap;
    color: ${({theme}) => theme.palette.text.secondary};
`;

export const LanguageSelectorButtonWrapper = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    
    gap: 4px;
    min-height: 18px;
    
    background: transparent;
    border: 1px solid ${({theme}) => theme.palette.dividers.subtle};
    cursor: pointer;
    padding: 4px 8px;
    border-radius: ${tokens.radius.sm};
    
    transition: all 0.2s ease;
    font-family: inherit;

    font-size: ${tokens.fontSize.xs};
    font-weight: ${tokens.fontWeight.semibold};
    
    white-space: nowrap;
    color: ${({theme}) => theme.palette.text.primary};
    
    &:hover {
        background-color: ${({theme}) => theme.palette.action.hover};
    }
`;

export const LanguageSelectorFlagWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    
    width: 24px;
    height: 18px;
    min-width: 24px;
    min-height: 18px;
    
    border-radius: ${tokens.radius.xs};
    overflow: hidden;
`;

export const LanguageSelectorLanguageNameWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: left;
    min-width: 24px;
    min-height: 18px;
`;

export const LanguageSelectorDropdownList = styled.div<{ $isOpen: boolean; $justify?: DropdownListJustify; }>`
    position: absolute;
    top: calc(100% + 8px);
    ${props => {
        switch (props.$justify) {
            case 'left':
                return {left: 0};
            case 'right':
                return {right: 0};
            default:
                return {};
        }
    }};
    
    background: ${({theme}) => theme.palette.background.paper};
    border: 1px solid ${({theme}) => theme.palette.dividers.subtle};
    border-radius: ${tokens.radius.md};
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    
    min-width: 150px;
    overflow: hidden;
    z-index: 1000;
    
    opacity: ${props => props.$isOpen ? '1' : '0'};
    visibility: ${props => props.$isOpen ? 'visible' : 'hidden'};
    transform: ${props => props.$isOpen ? 'translateY(0)' : 'translateY(-10px)'};
    transition: all 0.3s ease;
`;

export const LanguageSelectorDropdownListOption = styled.button<{ $isActive: boolean }>`
    padding: 12px 16px;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: ${tokens.fontSize.sm};
    
    border: none;
    width: 100%;
    text-align: left;
    
    color: ${({$isActive, theme}) => $isActive 
            ? theme.palette.text.primary : theme.palette.text.secondary };
    
    font-weight: ${({$isActive}) => $isActive 
            ? tokens.fontWeight.semibold : tokens.fontWeight.normal};
    background: ${({$isActive, theme}) => $isActive
            ? theme.palette.action.focused : 'transparent'};

    &:hover {
        background-color: ${({theme}) => theme.palette.action.hover};;
    }
`;

export const LanguageSelectorDropdownListOptionContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: left;
    gap: 6px;
`;
